import React, { useContext, useEffect } from "react";
import { useSport } from "./SportsProvider";
import { AuthContext } from "../components/login/AuthContext"; // ajuste le path si besoin

import GlobalRadioButton from "../components/UsefulComponent/GlobalRadioButton";
import translations from "../utils/language/translations.json";
import { useTranslation } from "react-i18next";

function normalizeCatalog(v) {
  const s = String(v || "").toLowerCase();
  if(!s) return null;
  console.log("Normalizing catalog value:", s); // Debug: check the normalized value
  if (s === "pokemon") return "Pokemon";
  if (s === "both") return "Both";
  return "Hockey";
}

export default function SportSwitcher({ className = "" }) {
  const { state, setSport } = useSport(); // state.sport: "Hockey" | "Pokemon"
  const { preferredCatalog } = useContext(AuthContext);
 console.log("Preferred Catalog:", preferredCatalog); // Debug: check the value of preferredCatalog
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.navbar?.[key]?.[currentLang] ?? key;

  const pref = normalizeCatalog(preferredCatalog);
 console.log("Normalized preferred catalog:", pref); // Debug: check the normalized preferred catalog
  // // ✅ Si user est "single", on force le sport et on ne montre pas le switcher
  useEffect(() => {
    if (pref === "Hockey" && state.sport !== "Hockey") setSport("Hockey");
    if (pref === "Pokemon" && state.sport !== "Pokemon") setSport("Pokemon");
    // pref === "Both" => on laisse le user choisir via le switcher
  }, [preferredCatalog]);

  // ✅ Si pas "Both", aucun switcher à afficher
 

  // Adapter: GlobalRadioButton peut renvoyer left/right/0/1/bool
  const setActiveType = (v) => {
    const val = typeof v === "string" ? v : v?.value ?? v;
    if (val === "Hockey" || val === "left" || val === 0 || val === true) return setSport("Hockey");
    if (val === "Pokemon" || val === "right" || val === 1 || val === false) return setSport("Pokemon");
  };

  return (
    <div className={`NavSportSwitcher ${className}`} aria-label="Content type">
      <GlobalRadioButton
        activeType={state.sport}
        setActiveType={setActiveType}
        leftLabel={"Hockey"}
        rightLabel={"Pokemon"}
        thisName="sport-switcher"
        size="sm"
        ariaLabel="Sport"
        t={t}
      />
      
    </div>
  );
}
